$(function() {
  Groupon.DFPAds || (Groupon.DFPAds = {});
  return Groupon.DFPAds.showAds = function() {
    return $('.dfp-footer').map(function() {
      return this.id;
    }).each(function(i, id) {
      return googletag.cmd.push(function() {
        return googletag.display(id);
      });
    });
  };
});

$(window).load(function() {
  var ref;
  return (ref = Groupon.DFPAds) != null ? typeof ref.showAds === "function" ? ref.showAds() : void 0 : void 0;
});

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvc2xhcmlzb24vbmFwaXN0cmFuby9idWlsZC8xNDk1MDUxMjg2NDY5LTIwMjk1L3JlbGVhc2VfYnJhbmNoXzIwMTdfMDVfMThfdGFnL29jY2FzaW9uc19hcHAvbW9kdWxlcy9kb3VibGVjbGljay9mcm9udGVuZC9kZnBfYWRzLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi92YXIvZ3JvdXBvbi9ob21lL3NsYXJpc29uL25hcGlzdHJhbm8vYnVpbGQvMTQ5NTA1MTI4NjQ2OS0yMDI5NS9yZWxlYXNlX2JyYW5jaF8yMDE3XzA1XzE4X3RhZy9vY2Nhc2lvbnNfYXBwL21vZHVsZXMvZG91YmxlY2xpY2svZnJvbnRlbmQvZGZwX2Fkcy5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsQ0FBQSxDQUFFLFNBQUE7RUFDQSxPQUFPLENBQUMsV0FBUixPQUFPLENBQUMsU0FBVztTQUVuQixPQUFPLENBQUMsTUFBTSxDQUFDLE9BQWYsR0FBeUIsU0FBQTtXQUN2QixDQUFBLENBQUUsYUFBRixDQUFnQixDQUFDLEdBQWpCLENBQXFCLFNBQUE7YUFDbkIsSUFBQyxDQUFBO0lBRGtCLENBQXJCLENBRUMsQ0FBQyxJQUZGLENBRU8sU0FBQyxDQUFELEVBQUksRUFBSjthQUNMLFNBQVMsQ0FBQyxHQUFHLENBQUMsSUFBZCxDQUFtQixTQUFBO2VBQ2pCLFNBQVMsQ0FBQyxPQUFWLENBQWtCLEVBQWxCO01BRGlCLENBQW5CO0lBREssQ0FGUDtFQUR1QjtBQUh6QixDQUFGOztBQVVBLENBQUEsQ0FBRSxNQUFGLENBQVMsQ0FBQyxJQUFWLENBQWUsU0FBQTtBQUNiLE1BQUE7aUZBQWMsQ0FBRTtBQURILENBQWYifQ==
